import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import 'core-js/client/shim';
import 'zone.js/dist/zone';
import 'zone.js/dist/long-stack-trace-zone';
import 'web-animations-js/web-animations.min';
import 'zone.js/dist/webapis-shadydom';
